import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20ink%20wash%20landscape%20with%20full%20moon%20over%20misty%20mountains%2C%20ancient%20pine%20trees%20silhouette%2C%20floating%20clouds%2C%20golden%20warm%20light%20blending%20with%20cool%20moonlight%2C%20dreamy%20poetic%20atmosphere%2C%20classical%20Chinese%20painting%20aesthetic%2C%20minimalist%20composition%2C%20soft%20gradients%2C%20spiritual%20tranquility&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="爱风月 - 风月美学意境"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/20 to-black/55" />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <p className="text-accent-300 font-heading text-lg md:text-xl tracking-[0.3em] mb-4 animate-[fadeInDown_1s_ease-out]">
          风雅情趣 · 生活美学
        </p>
        <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 tracking-wide animate-[fadeInUp_1s_ease-out]">
          {siteConfig.name}
        </h1>
        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed animate-[fadeInUp_1.2s_ease-out]">
          一种对生活诗意与浪漫的深情追求。汇聚风月文化内涵、生活方式与美学体验，
          带你领略风月之间最真实的雅致与情韵。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-[fadeInUp_1.4s_ease-out]">
          <Link
            to="/category/fengya-shenghuo"
            className="whitespace-nowrap px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-all duration-300 text-sm tracking-wide"
          >
            探索风月之美
          </Link>
          <Link
            to="/about"
            className="whitespace-nowrap px-8 py-3.5 border border-white/30 hover:border-white/60 text-white font-medium rounded-full transition-all duration-300 text-sm tracking-wide"
          >
            了解品牌故事
          </Link>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/60 text-2xl" />
      </div>
    </section>
  );
}